import { useEffect, useState } from "react"
import { useAuth } from "../../../Providers/AuthProvider"


const useGetProductPrices = (product, quantityInBasket = 1) => {
    const { wholesalePrices } = useAuth()

    const [priceNet, setPriceNet] = useState(0)
    const [priceGross, setPriceGross] = useState(0)
    const [priceNetTotal, setPriceNetTotal] = useState(0)
    const [priceGrossTotal, setPriceGrossTotal] = useState(0)

    useEffect(() => {
        handleReCalculatePrices(quantityInBasket)
    }, [product, wholesalePrices])

    const handleReCalculatePrices = (quantityInBasket) => {
        var tmpQuantityInBasket = !quantityInBasket || quantityInBasket === 0 ? 1 : quantityInBasket

        if (product && product.priceNet && product.priceGross) {
            setPriceNet(wholesalePrices ? product.priceNet : product.priceNetBase)
            setPriceGross(wholesalePrices ? product.priceGross : product.priceGrossBase)

            setPriceNetTotal(wholesalePrices ? product.priceNet * tmpQuantityInBasket : product.priceNetBase * tmpQuantityInBasket)
            setPriceGrossTotal(wholesalePrices ? product.priceGross * tmpQuantityInBasket : product.priceGrossBase * tmpQuantityInBasket)
        }
    }

    return { priceNet, priceGross, priceNetTotal, priceGrossTotal, handleReCalculatePrices, }
}

export default useGetProductPrices